<div class="blockCard">

  <div class="row">
    <div class="col-10">

      <h3>{{title}}</h3>
      <p>{{description}}</p>

    </div>
  </div>

  <div class="row">
    <div class="tycContainer col-10 center">
      <mat-checkbox color="primary" [(ngModel)]="accepted"></mat-checkbox>
      {{textCheckbox}}
    </div>
  </div>

  <div class="row">
    <div class="col-10 center">
      <button mat-raised-button color="primary" (click)="saveAcceptanceMoneyPolicy()" [disabled]="!accepted">Continuar</button>
    </div>
  </div>
</div>
